var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.to && !_vm.showLoader ? _c('router-link', _vm._g(_vm._b({
    ref: "iconButton",
    staticClass: "mini_actions_v2_button",
    class: {
      disabled: _vm.computedDisabled,
      disable_scaling: _vm.disableScaleOnHover,
      semi_transparent: _vm.showLoader
    },
    attrs: {
      "disabled": _vm.computedDisabled,
      "to": _vm.to,
      "flat": ""
    }
  }, 'router-link', _vm.computedProps, false), _vm.$listeners), [_vm._t("default", function () {
    return [_c('c-icon-fa', {
      attrs: {
        "icon": _vm.icon,
        "icon-color": _vm.computedIconColor,
        "icon-size": _vm.computedIconSize,
        "flip-horizontal": _vm.iconFlipHorizontal,
        "flip-vertical": _vm.iconFlipVertical
      }
    }), _vm.label ? _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()];
  }), _c('c-spinner', {
    class: {
      spinner: true,
      spinner_active: _vm.showLoader
    },
    attrs: {
      "color": _vm.computedIconColor
    }
  })], 2) : _vm.href ? _c('a', _vm._g(_vm._b({
    ref: "iconButton",
    staticClass: "mini_actions_v2_button",
    class: {
      disabled: _vm.computedDisabled,
      disable_scaling: _vm.disableScaleOnHover,
      semi_transparent: _vm.showLoader
    },
    attrs: {
      "disabled": _vm.computedDisabled
    }
  }, 'a', _vm.computedProps, false), _vm.$listeners), [_vm._t("default", function () {
    return [_c('c-icon-fa', {
      attrs: {
        "icon": _vm.icon,
        "icon-color": _vm.computedIconColor,
        "icon-size": _vm.computedIconSize,
        "flip-horizontal": _vm.iconFlipHorizontal,
        "flip-vertical": _vm.iconFlipVertical
      }
    }), _vm.label ? _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()];
  }), _c('c-spinner', {
    class: {
      spinner: true,
      spinner_active: _vm.showLoader
    },
    attrs: {
      "color": _vm.computedIconColor
    }
  })], 2) : _c('button', _vm._g(_vm._b({
    ref: "iconButton",
    staticClass: "mini_actions_v2_button",
    class: {
      disabled: _vm.computedDisabled,
      disable_scaling: _vm.disableScaleOnHover,
      semi_transparent: _vm.showLoader
    },
    attrs: {
      "disabled": _vm.computedDisabled,
      "type": "button"
    }
  }, 'button', _vm.computedProps, false), _vm.$listeners), [_vm._t("default", function () {
    return [_c('c-icon-fa', {
      attrs: {
        "icon": _vm.icon,
        "icon-color": _vm.computedIconColor,
        "icon-size": _vm.computedIconSize,
        "flip-horizontal": _vm.iconFlipHorizontal,
        "flip-vertical": _vm.iconFlipVertical
      }
    }), _vm.label ? _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()];
  }), _c('c-spinner', {
    class: {
      spinner: true,
      spinner_active: _vm.showLoader
    },
    attrs: {
      "color": _vm.computedIconColor
    }
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };